import React, {useEffect, useState} from 'react'
import {StoryItemProps} from '../../constants'
import {actionStoryDetailModalOpen} from '../../redux/modal'
import {useDispatch} from 'react-redux'
import {UiIcon} from '../../components/UiIcon'
import './StoryCatalog.scss'

export function storyCoverUrl(item: StoryItemProps['item']) {
  return `${item.basePath || ''}${item.fileProfiles?.[0]?.filePath || ''}${item.thumbnail || ''}`.replace(/file\.kidly\.world/g, 'files.gokidly.com')
}
export function StoryItem({item, checked, handleSetSelectedStoryId, disabled}: StoryItemProps) {
  const dispatch = useDispatch()
  const [imageError, setImageError] = useState(false)
  const cover = storyCoverUrl(item)
  useEffect(() => setImageError(false), [cover])
  const open = () => dispatch(actionStoryDetailModalOpen({StoryId: item.storyId, StoryDetailId: item.storyDetailId, LanguageCode: item.languageCode}))
  return (
    <article className={`edu-book-card${checked ? ' is-selected' : ''}`}>
      <button type='button' className='edu-book-cover' onClick={open} aria-label={`${item.title}: kitap detayını aç`}>
        {imageError || !item.thumbnail ? <span className='edu-book-fallback'><UiIcon name='book' size={36}/><span>Kapak görseli yok</span></span>
          : <img src={cover} alt='' loading='lazy' onError={() => setImageError(true)} />}
        <span className='edu-book-preview'>Kitabı incele <UiIcon name='arrow' size={14}/></span>
      </button>
      <div className='edu-book-info'>
        <h3 title={item.title}>{item.title}</h3>
        <p>{item.author || item.categories || (item.languageCode === 'tr-TR' ? 'Türkçe' : item.languageCode === 'en-US' ? 'English' : item.languageCode)}</p>
        <button type='button' className='edu-book-select' disabled={disabled} aria-pressed={Boolean(checked)} aria-label={`${item.title}: ${checked ? 'seçimi kaldır' : 'kitabı seç'}`} onClick={() => handleSetSelectedStoryId(item.storyId)}>
          <UiIcon name={checked ? 'check' : 'plus'} size={17}/>{checked ? 'Seçildi' : 'Kitabı seç'}
        </button>
      </div>
    </article>
  )
}
